module.exports = __webpack_public_path__ + "img/winning prize.24a01fce.svg";